import React from 'react'
import {connect} from 'react-redux'
import {change as changeFieldValue, Field, formValueSelector, reduxForm} from 'redux-form';
import $ from 'jquery';
import {bindActionCreators} from 'redux';
import {maxValueMonetario, renderFieldMonetario, renderTextArea, required} from '../../../util/inputs';
import {realParaNumber} from '../../../util/numberUtil';
import enviarFechamentoCaixa from '../../../actions/fechamento-caixa/agencia/enviarFechamentoCaixa';
import {
    getAdminEmpresa,
    getFinanceiroAgencia, getFinanceiroCaixa,
    getGestorEmpresa,
    getOperadorEmpresa,
} from '../../../security/securityContext';
import Autorizacao, {validaPerfis} from '../../../security/Autorizacao';
import devolverFechamentoCaixa from '../../../actions/fechamento-caixa/agencia/devolverFechamentoCaixa';

import aprovarFechamentoCaixa from '../../../actions/fechamento-caixa/agencia/aprovarFechamentoCaixa';
import {tamanhoArquivoUpload} from '../../../util/applicationContext';
import salvarFechamentoCaixa from '../../../actions/fechamento-caixa/agencia/salvarFechamentoCaixa';
import {showSuccessMsg} from '../../../util/messagesUtil';

export class ModalFechamentoCaixaAgencia extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            comprovante: null,
            nomeComprovante: null
        };
        this.submit = this.submit.bind(this);
        this.alterarValorTotal = this.alterarValorTotal.bind(this);
        this.salvarFechamento = this.salvarFechamento.bind(this);
    }

    fecharModal() {
        $('#modalFechamentoCaixaAgencia')
            .modal('hide');
        $('#modalFechamentoCaixaAgencia')
            .hide();
        $('.modal-backdrop')
            .hide();
        this.props.reset('formularioFechamentoCaixa')
    }

    submit(values, buscarFechamentos) {
        const parametros = {
            totalDespesas: values.totalDespesas.replace('R$', ''),
            observacao: values.observacao,
            base64ComprovanteTransferencia: this.props.base64ComprovanteTransferencia,
            nomeComprovanteTransferencia: this.props.nomeComprovanteTransferencia,
            base64Boleto: this.props.base64Boleto,
            nomeBoleto: this.props.nomeBoleto,
            data: this.props.fechamentoCaixa.dataFechamento,
            idAgencia: this.props.fechamentoCaixa.idAgencia
        };
        if (this.state.botao === 'salvar') {
            this.salvarFechamento(parametros, buscarFechamentos)
        } else {
            this.enviarFechamento(parametros, buscarFechamentos)
        }
    }

    enviarFechamento(parametros, buscarFechamentos) {
        this.props.enviarFechamentoCaixa(this.props.empresaSelecionada.id, parametros)
            .then(() => {
                showSuccessMsg('Fechamento enviado com sucesso');
                this.fecharModal();
                buscarFechamentos()
            })
    }

    salvarFechamento(parametros, buscarFechamentos) {
        this.props.salvarFechamentoCaixa(this.props.empresaSelecionada.id, parametros)
            .then(() => {
                showSuccessMsg('Fechamento salvo com sucesso');
                this.fecharModal();
                buscarFechamentos();
            })
    }

    handleChangeComprovanteTransferencia(event) {
        const file = event.target.files[0];
        if (!this.validarArquivo(file)) {
            return
        }
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            this.props.changeFieldValue('formularioFechamentoCaixa',
                'base64ComprovanteTransferencia', reader.result);
            this.props.changeFieldValue('formularioFechamentoCaixa',
                'nomeComprovanteTransferencia', file.name);
        }.bind(this);
    }

    handleChangeBoleto(event) {
        const file = event.target.files[0];
        if (!this.validarArquivo(file)) {
            return
        }
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            this.props.changeFieldValue('formularioFechamentoCaixa',
                'base64Boleto', reader.result);
            this.props.changeFieldValue('formularioFechamentoCaixa',
                'nomeBoleto', file.name);
        }.bind(this);
    }

    validarArquivo(file) {
        if (/\.(jpe?g|png|pdf)$/i.test(file.name) === false) {
            return false;
        }
        if (file.size > tamanhoArquivoUpload) {
            showSuccessMsg('Tamanho do arquivo excede 20 MB');
            return false;
        }

        return true;
    }

    removerArquivoComprovanteTransferencia() {
        this.props.changeFieldValue('formularioFechamentoCaixa',
            'base64ComprovanteTransferencia', null);
        this.props.changeFieldValue('formularioFechamentoCaixa',
            'nomeComprovanteTransferencia', null);
        this.props.changeFieldValue('formularioFechamentoCaixa',
            'urlComprovanteTransferencia', null);
    }

    removerArquivoBoleto() {
        this.props.changeFieldValue('formularioFechamentoCaixa',
            'base64Boleto', null);
        this.props.changeFieldValue('formularioFechamentoCaixa',
            'nomeBoleto', null);
        this.props.changeFieldValue('formularioFechamentoCaixa',
            'urlBoleto', null);
    }


    alterarValorTotal = (event) => {
        event.preventDefault();
        let valor = realParaNumber(this.props.totalVendas);

        valor = this.calcularValor(valor, event, 'totalCustoCancelamento', this.props.totalCustoCancelamento, true);
        valor = this.calcularValor(valor, event, 'totalCancelamento', this.props.totalCancelamento);
        valor = this.calcularValor(valor, event, 'totalDespesas', this.props.totalDespesas);
        valor = this.calcularValor(valor, event, 'totalImpostoRetido', this.props.totalImpostoRetido);
        valor = this.calcularValor(valor, event, 'totalTarifaSeguro', this.props.totalTarifaSeguro);
        valor = this.calcularValor(valor, event, 'totalComissao', this.props.totalComissao);
        valor = this.calcularValor(valor, event, 'totalDesconto', this.props.totalDesconto);
        valor = this.calcularValor(valor, event, 'totalRecebidoCartao', this.props.totalRecebidoCartao);
        this.props.changeFieldValue('formularioFechamentoCaixa',
            'totalDeposito', valor.toString()
                .replace('.', ','));
    };

    calcularValor(valorTotal, event, nomeCampo, total, isSoma) {
        const valor = event.target.name === nomeCampo ? realParaNumber(event.target.value) : realParaNumber(total);
        return isSoma ? valorTotal + valor : valorTotal - valor;
    }

    exibirAnexarComprovanteTransferencia() {
        if (this.props.base64ComprovanteTransferencia || this.props.urlComprovanteTransferencia) {
            return (
                <div className="row align-items-center mt-2">
                    <div className='col-md-6 label-cancelamento ml-2'>
                        <strong>Comprovante:</strong>
                    </div>
                    <span>{this.props.nomeComprovanteTransferencia}</span>
                    {this.exibirRemoverComprovante()}
                    {this.exibirBaixarComprovante()}
                </div>)
        }
        return (
            <Autorizacao perfisPermitidos={[
                getGestorEmpresa(this.props.empresaSelecionada.id),
                getAdminEmpresa(this.props.empresaSelecionada.id),
                getOperadorEmpresa(this.props.empresaSelecionada.id),
                getFinanceiroCaixa(this.props.empresaSelecionada.id),
                getFinanceiroAgencia(this.props.empresaSelecionada.id)
            ]}>
                <div className='input-wrapper mt-3'>
                    <label className='btn-laranja' htmlFor='input-file-comprovante-deposito'>
                        <div className='row align-items-center'>
                            <i className="material-icons aberto">&#xe2c3;</i>
                            <strong className='ml-2'>Anexar comprovante de depósito</strong>
                        </div>
                    </label>
                    <input id='input-file-comprovante-deposito' type='file' value=''
                           accept="image/png,image/jpeg,application/pdf"
                           onChange={this.handleChangeComprovanteTransferencia.bind(this)}/>
                </div>
            </Autorizacao>)
    }

    exibirAnexarBoleto() {
        if (this.props.base64Boleto || this.props.urlBoleto) {
            return (
                <div className="row align-items-center mt-2">
                    <div className='col-md-6 label-cancelamento ml-2'>
                        <strong>Boleto:</strong>
                    </div>
                    <span>{this.props.nomeBoleto}</span>
                    {this.exibirRemoverBoleto()}
                    {this.exibirBaixarBoleto()}
                </div>)
        }
        if ((this.props.fechamentoCaixa.situacao === 'ABERTO' || this.props.fechamentoCaixa.situacao === 'DEVOLVIDO')) {
            return (<Autorizacao perfisPermitidos={[
                getGestorEmpresa(this.props.empresaSelecionada.id),
                getAdminEmpresa(this.props.empresaSelecionada.id),
                getFinanceiroCaixa(this.props.empresaSelecionada.id),
                getOperadorEmpresa(this.props.empresaSelecionada.id)
            ]}>
                <div className='input-wrapper mt-3'>
                    <label className='btn-laranja' htmlFor='input-file-boleto'>
                        <div className='row align-items-center'>
                            <i className="material-icons aberto">&#xe2c3;</i>
                            <strong className='ml-2'>Anexar Boleto</strong>
                        </div>
                    </label>
                    <input id='input-file-boleto' type='file' value='' accept="image/png,image/jpeg,application/pdf"
                           onChange={this.handleChangeBoleto.bind(this)}/>
                </div>
            </Autorizacao>)
        }
        return '';
    }

    exibirAnexar() {
        return (<React.Fragment>
            {this.exibirAnexarComprovanteTransferencia()}
            {this.exibirAnexarBoleto()}
            {!(this.props.base64ComprovanteTransferencia || this.props.urlComprovanteTransferencia) || !(this.props.base64Boleto || this.props.urlBoleto) ?
                <label style={{fontSize: 'smaller'}}>
                    * Tamanho máximo permitido: 20 MB
                    <br/>
                    * Formatos suportados: PNG, JPEG, PDF
                    <br/>
                    * Se desejar anexar mais de um arquivo de imagem, utilize o seguinte link para uni-los:
                    <a target="_BLANK" href='https://smallpdf.com/pt/jpg-para-pdf'
                       rel='noreferrer'> https://smallpdf.com/pt/jpg-para-pdf.</a>
                    <br/>
                    * Se desejar anexar mais de um arquivo PDF, utilize o seguinte link para uni-los:
                    <a target="_BLANK" href='https://smallpdf.com/pt/juntar-pdf'
                       rel='noreferrer'> https://smallpdf.com/pt/juntar-pdf.</a>
                </label> : ''}
        </React.Fragment>)
    }

    exibirBaixarComprovante() {
        if (this.props.urlComprovanteTransferencia) {
            return (<Autorizacao perfisPermitidos={[
                getGestorEmpresa(this.props.empresaSelecionada.id),
                getAdminEmpresa(this.props.empresaSelecionada.id),
                getFinanceiroCaixa(this.props.empresaSelecionada.id),
                getOperadorEmpresa(this.props.empresaSelecionada.id),
                getFinanceiroAgencia(this.props.empresaSelecionada.id)
            ]}>
                <button type="button" className="btn btn-editar"
                        title='Baixar'
                        onClick={() => window.open(this.props.urlComprovanteTransferencia, '_blank')}>
                    <i className="material-icons nav-icon" style={{
                        color: '#fa8d42'
                    }}>&#xe2c0;</i>
                </button>
            </Autorizacao>)
        }
        return '';
    }

    exibirBaixarBoleto() {
        if (this.props.urlBoleto) {
            return (<Autorizacao perfisPermitidos={[
                getGestorEmpresa(this.props.empresaSelecionada.id),
                getAdminEmpresa(this.props.empresaSelecionada.id),
                getOperadorEmpresa(this.props.empresaSelecionada.id),
                getFinanceiroCaixa(this.props.empresaSelecionada.id),
                getFinanceiroAgencia(this.props.empresaSelecionada.id)
            ]}>
                <button type="button" className="btn btn-editar"
                        title='Baixar'
                        onClick={() => window.open(this.props.urlBoleto, '_blank')}>
                    <i className="material-icons nav-icon" style={{
                        color: '#fa8d42'
                    }}>&#xe2c0;</i>
                </button>
            </Autorizacao>)
        }
        return '';
    }

    exibirRemoverComprovante() {
        if ((this.props.fechamentoCaixa.situacao === 'ABERTO' || this.props.fechamentoCaixa.situacao === 'DEVOLVIDO')) {
            return (<Autorizacao perfisPermitidos={[
                getGestorEmpresa(this.props.empresaSelecionada.id),
                getAdminEmpresa(this.props.empresaSelecionada.id),
                getOperadorEmpresa(this.props.empresaSelecionada.id),
                getFinanceiroCaixa(this.props.empresaSelecionada.id),
                getFinanceiroAgencia(this.props.empresaSelecionada.id)
            ]}>
                <button type="button" className="btn btn-editar"
                        title='Remover'
                        onClick={() => this.removerArquivoComprovanteTransferencia()}>
                    <i className="material-icons nav-icon" style={{
                        color: 'red'
                    }}>&#xe14c;</i>
                </button>
            </Autorizacao>)
        }
    }

    exibirRemoverBoleto() {
        if ((this.props.fechamentoCaixa.situacao === 'ABERTO' || this.props.fechamentoCaixa.situacao === 'DEVOLVIDO')) {
            return (<Autorizacao perfisPermitidos={[
                getGestorEmpresa(this.props.empresaSelecionada.id),
                getAdminEmpresa(this.props.empresaSelecionada.id),
                getFinanceiroCaixa(this.props.empresaSelecionada.id),
                getOperadorEmpresa(this.props.empresaSelecionada.id)
            ]}>
                <button type="button" className="btn btn-editar"
                        title='Remover'
                        onClick={() => this.removerArquivoBoleto()}>
                    <i className="material-icons nav-icon" style={{
                        color: 'red'
                    }}>&#xe14c;</i>
                </button>
            </Autorizacao>)
        }
    }

    exibirBotoesFinanceiroAgencia(invalid, submitting) {
        if (this.props.fechamentoCaixa.situacao === 'ABERTO' || this.props.fechamentoCaixa.situacao === 'DEVOLVIDO') {
            return (
                <div className="modal-footer">
                    <button id="btn-cancelar-acesso-autos" className="btn btn-azul" data-dismiss="modal"
                            disabled={submitting}>
                        CANCELAR
                    </button>
                    <Autorizacao perfisPermitidos={[
                        getFinanceiroAgencia(this.props.empresaSelecionada.id),
                        getGestorEmpresa(this.props.empresaSelecionada.id),
                        getAdminEmpresa(this.props.empresaSelecionada.id),
                        getFinanceiroCaixa(this.props.empresaSelecionada.id),
                        getOperadorEmpresa(this.props.empresaSelecionada.id)
                    ]}>
                        <button type="submit" title='Salvar custos do dia' className="btn btn-azul"
                                onClick={() => this.setState({botao: 'salvar'})} disabled={invalid || submitting}>
                            SALVAR
                        </button>
                        <button type="submit" title='Enviar para aprovação do gestor' className="btn btn-azul"
                                onClick={() => this.setState({botao: 'enviar'})}
                                disabled={invalid || submitting || !this.props.nomeComprovanteTransferencia}>
                            ENVIAR
                        </button>
                    </Autorizacao>
                </div>)
        }
        return ''
    }

    devolverFechamentoCaixa() {
        this.props.devolverFechamentoCaixa(this.props.fechamentoCaixa.id, this.props.observacao, this.props.empresaSelecionada.id)
            .then(() => {
                showSuccessMsg('Fechamento devolvido com sucesso');
                this.fecharModal();
                this.props.buscaFechamentos();
            })
    }

    aprovarFechamentoCaixa() {
        this.props.aprovarFechamentoCaixa(this.props.fechamentoCaixa.id, this.props.observacao, this.props.empresaSelecionada.id)
            .then(() => {
                showSuccessMsg('Fechamento aprovado com sucesso');
                this.fecharModal();
                this.props.buscaFechamentos();
            })
    }


    exibirBotoesGestorOperador() {
        if (this.props.fechamentoCaixa.situacao === 'ENVIADO') {
            return (
                <div className="modal-footer">
                    <button id="btn-cancelar-acesso-autos" className="btn btn-azul" data-dismiss="modal">
                        CANCELAR
                    </button>
                    <Autorizacao perfisPermitidos={[getGestorEmpresa(this.props.empresaSelecionada.id),
                        getAdminEmpresa(this.props.empresaSelecionada.id),
                        getFinanceiroCaixa(this.props.empresaSelecionada.id),
                        getOperadorEmpresa(this.props.empresaSelecionada.id)]}>
                        <button className="btn btn-vermelho" id="btn-confirmar-acesso-autos"
                                onClick={() => this.devolverFechamentoCaixa()}>
                            DEVOLVER
                        </button>
                        <button className="btn btn-laranja" id="btn-confirmar-acesso-autos"
                                onClick={() => this.aprovarFechamentoCaixa()}>
                            APROVAR
                        </button>
                    </Autorizacao>
                </div>)
        }
        return ''
    }

    render() {
        const {
            handleSubmit, submitting, invalid
        } = this.props;

        const naoPodeAlterarValores = !validaPerfis([
                getGestorEmpresa(this.props.empresaSelecionada.id),
                getAdminEmpresa(this.props.empresaSelecionada.id),
                getFinanceiroCaixa(this.props.empresaSelecionada.id),
                getOperadorEmpresa(this.props.empresaSelecionada.id),
                getFinanceiroAgencia(this.props.empresaSelecionada.id)])
            || (this.props.fechamentoCaixa.id && (this.props.fechamentoCaixa.situacao === 'ENVIADO' || this.props.fechamentoCaixa.situacao === 'APROVADO'));

        const exibirCampoComentario = (validaPerfis([
                    getGestorEmpresa(this.props.empresaSelecionada.id),
                    getAdminEmpresa(this.props.empresaSelecionada.id),
                    getFinanceiroCaixa(this.props.empresaSelecionada.id),
                    getFinanceiroAgencia(this.props.empresaSelecionada.id),
                    getOperadorEmpresa(this.props.empresaSelecionada.id)]) && (this.props.fechamentoCaixa.situacao === 'ABERTO' || this.props.fechamentoCaixa.situacao === 'DEVOLVIDO')
            )
            || (validaPerfis([ getAdminEmpresa(this.props.empresaSelecionada.id), getGestorEmpresa(this.props.empresaSelecionada.id)]) && (this.props.fechamentoCaixa.situacao === 'ENVIADO'));

        return (
            <div className="modal fade show" id="modalFechamentoCaixaAgencia" role="dialog"
                 aria-labelledby="modalFechamentoCaixaAgencia"
                 aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <div className="modal-title">
                                <h5>
                                    {this.props.fechamentoCaixa.nomeAgencia} - {this.props.fechamentoCaixa.dataFechamento}
                                </h5>
                            </div>
                            <button id="btn-cabecalho-modal" className="close" type="button" data-dismiss="modal"
                                    aria-label="Close" onClick={() => this.fecharModal()}>
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <form onSubmit={handleSubmit((values) => {
                            this.submit(values, this.props.buscaFechamentos)
                        })}>
                            <div className='modal-body'>
                                <Field name='totalDespesas' validate={[required, maxValueMonetario]}
                                       component={renderFieldMonetario} className="form-control"
                                       label="(-) Total despesas" handleChange={this.alterarValorTotal}
                                       readOnly={naoPodeAlterarValores}/>
                                <Field name='totalImpostoRetido' validate={[required, maxValueMonetario]}
                                       component={renderFieldMonetario} className="form-control"
                                       label="(-) Total imposto retido" readOnly/>
                                <Field name='totalImpostoRetido' validate={[required, maxValueMonetario]}
                                       component={renderFieldMonetario} className="form-control"
                                       label="(-) Total tarifa seguro" readOnly/>
                                <Field name='totalVendas' validate={[required]} component={renderFieldMonetario}
                                       className="form-control" label='(+) Total de vendas' readOnly/>
                                <Field name='totalRecebidoCartao' validate={[required]} component={renderFieldMonetario}
                                       className="form-control" label="(-) Total recebido cartão" readOnly/>
                                <Field name='totalCancelamento' validate={[required]} component={renderFieldMonetario}
                                       className="form-control" label="(-) Total de cancelamentos" readOnly/>
                                <Field name='totalCustoCancelamento' validate={[required]}
                                       component={renderFieldMonetario} className="form-control"
                                       label="(+) Total de residual de cancelamentos" readOnly/>
                                <Field name='totalComissao' validate={[required]} component={renderFieldMonetario}
                                       className="form-control" label="(-) Total comissão" readOnly/>
                               <Field name='totalReimpressaoRecibo' validate={[required]} component={renderFieldMonetario}
                                      className="form-control" label="(-) Total comissão Reimpressão" readOnly/>
                                <Field name='totalDesconto' validate={[required]} component={renderFieldMonetario}
                                       className="form-control" label="( Informativo ) Total desconto" readOnly/>
                                <Field name='totalTaxaEmbarqueCEA' validate={[required, maxValueMonetario]}
                                       component={renderFieldMonetario} className="form-control"
                                       label='(=) Total Tx de Embaque CEA'
                                       handleChange={this.alterarValorTotal} readOnly/>
                                <Field name='totalDeposito' validate={[required]} component={renderFieldMonetario}
                                       className="form-control" label="(=) Total do deposito" readOnly/>
                                {exibirCampoComentario ?
                                    <Field name='observacao' css="form-control col-md-12" component={renderTextArea}
                                           className="form-control" max={1500} label="Seu comentário:"/> : ''}
                                {this.props.fechamentoCaixa.situacao === 'ABERTO' && !this.props.fechamentoCaixa.ultimoHistorico ? '' :
                                    <Field name='ultimoComentario' css="form-control col-md-12"
                                           component={renderTextArea} className="form-control"
                                           label="Último comentário:" readOnly={true}/>}
                                {this.exibirAnexar()}
                            </div>
                            {this.exibirBotoesFinanceiroAgencia(invalid, submitting)}
                        </form>
                        {this.exibirBotoesGestorOperador()}
                    </div>
                </div>
            </div>
        )
    }
}

const selector = formValueSelector('formularioFechamentoCaixa');

export function mapStateToProps(state) {
    return {
        vendas: state.vendas,
        empresaSelecionada: state.empresaSelecionada,
        fechamentoCaixa: state.fechamentoCaixa,
        paginaAtual: state.paginaAtualFechamentoCaixa,
        registrosPorPagina: state.registrosPorPaginaFechamentoCaixa,
        initialValues: {
            totalTaxaEmbarqueCEA: state.fechamentoCaixa.totais.totalTaxaEmbarqueCEA,
            totalDespesas: state.fechamentoCaixa.totais.totalDespesas,
            totalImpostoRetido: state.fechamentoCaixa.totais.totalImpostoRetido,
            totalTarifaSeguro: state.fechamentoCaixa.totais.totalTarifaSeguro,
            totalVendas: state.fechamentoCaixa.totais.totalVendas,
            totalRecebidoCartao: state.fechamentoCaixa.totais.totalRecebidoCartao,
            totalCancelamento: state.fechamentoCaixa.totais.totalCancelamento,
            totalCustoCancelamento: state.fechamentoCaixa.totais.totalCustoCancelamento,
            totalReimpressaoRecibo: state.fechamentoCaixa.totais.totalReimpressaoRecibo,
            totalComissao: state.fechamentoCaixa.totais.totalComissao,
            totalDesconto: state.fechamentoCaixa.totais.totalDesconto,
            totalDeposito: state.fechamentoCaixa.totais.totalDeposito,
            ultimoComentario: state.fechamentoCaixa.ultimoHistorico ? state.fechamentoCaixa.ultimoHistorico.observacao : '',
            urlComprovanteTransferencia: state.fechamentoCaixa.urlComprovanteTransferencia ? state.fechamentoCaixa.urlComprovanteTransferencia : null,
            nomeComprovanteTransferencia: state.fechamentoCaixa.nomeComprovanteTransferencia ? state.fechamentoCaixa.nomeComprovanteTransferencia : null,
            urlBoleto: state.fechamentoCaixa.urlBoleto ? state.fechamentoCaixa.urlBoleto : null,
            nomeBoleto: state.fechamentoCaixa.nomeBoleto ? state.fechamentoCaixa.nomeBoleto : null
        },
        totalTaxaEmbarqueCEA: selector(state, 'totalTaxaEmbarqueCEA'),
        totalCancelamento: selector(state, 'totalCancelamento'),
        totalCustoCancelamento: selector(state, 'totalCustoCancelamento'),
        totalDespesas: selector(state, 'totalDespesas'),
        totalImpostoRetido: selector(state, 'totalImpostoRetido'),
        totalTarifaSeguro: selector(state, 'totalTarifaSeguro'),
        totalTarifaSeguroImpostoRetido: selector(state, 'totalTarifaSeguroImpostoRetido'),
        totalVendas: selector(state, 'totalVendas'),
        totalRecebidoCartao: selector(state, 'totalRecebidoCartao'),
        totalFrete: selector(state, 'totalFrete'),
        totalExcessoBagagem: selector(state, 'totalExcessoBagagem'),
        totalComissao: selector(state, 'totalComissao'),
        totalReimpressaoRecibo: selector(state, 'totalReimpressaoRecibo'),
        totalDesconto: selector(state, 'totalDesconto'),
        totalDeposito: selector(state, 'totalDeposito'),
        urlComprovanteTransferencia: selector(state, 'urlComprovanteTransferencia'),
        nomeComprovanteTransferencia: selector(state, 'nomeComprovanteTransferencia'),
        base64ComprovanteTransferencia: selector(state, 'base64ComprovanteTransferencia'),
        urlBoleto: selector(state, 'urlBoleto'),
        nomeBoleto: selector(state, 'nomeBoleto'),
        base64Boleto: selector(state, 'base64Boleto'),
        observacao: selector(state, 'observacao')
    }
}

export const mapDispatchToProps = dispatch => (
    bindActionCreators({
        changeFieldValue,
        enviarFechamentoCaixa,
        aprovarFechamentoCaixa,
        devolverFechamentoCaixa,
        salvarFechamentoCaixa
    }, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
    form: 'formularioFechamentoCaixa',
    enableReinitialize: true,
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
})(ModalFechamentoCaixaAgencia))
